import { SimpleBars } from '../../../Common/Charts/SimpleBars';
import { getYearLabel } from '../../../Common/Util/getYearLabel';
import { useConditionalityChartsDataContext } from './hooks/useConditionalityChartsDataContext';

export const WithInformedHealthConditionsComparisonPercentageAnual = () => {
    const { chartData } = useConditionalityChartsDataContext();

    return (
        <SimpleBars
            title={'Comparação de Condições de Saúde Informadas - Percentual (Anual)'}
            horizontal={false}
            subtitles={chartData?.withInformedHealthConditionsComparisonPercentageAnual?.map((item) => getYearLabel(item.ano))}
            values={chartData?.withInformedHealthConditionsComparisonPercentageAnual?.map((item) => item.percentage || 0)}
        />
    );
};
